import { useEffect } from 'react';
import { getStores } from '@/stores/stores';

interface UseGameScoringProps {
  sampleId: string | null;
  userId: string | null;
}

/**
 * Simple hook that uses MobX gamification store and follows singleton pattern 
 */
export const useGameScoring = ({ sampleId, userId }: UseGameScoringProps) => {
  const { gamificationStore } = getStores(false, {});

  // Update the store context when props change
  useEffect(() => {
    gamificationStore.updateContext(sampleId, userId);
  }, [sampleId, userId, gamificationStore]);

  useEffect(() => {
    console.log('[DEBUG useGamification.ts] Save progress toggled:', gamificationStore.saveProgressEnabled);
  }, [gamificationStore.saveProgressEnabled])
  

  return {
    gameState: gamificationStore.gameState,
    isPerfectRun: gamificationStore.isPerfectRun,
    resetProgress: gamificationStore.resetProgress,
    isGamificationLoading: gamificationStore.isGamificationLoading,
    gamificationEnabled: gamificationStore.gamificationEnabled,
    toggleGamification: gamificationStore.toggleGamification,
    saveProgressEnabled: gamificationStore.saveProgressEnabled,
    toggleSaveProgress: gamificationStore.toggleSaveProgress,
  };
};